import * as amplitude from '@amplitude/analytics-browser';

export type SearchFormInteractionType =
    | 'passenger_count_changed'
    | 'origin_destination_swapped';

interface SearchSubmittedArgs {
    arriveAddress: string;
    arrivePlaceId: string;
    departAddress: string;
    departPlaceId: string;
    isOneWay: boolean;
    outboundDateSearched: string;
    paxCount: number;
    returnDateSearched?: string;
}

interface SearchFormInteractedArgs {
    interactionType: SearchFormInteractionType;
    updatedFrom?: string;
    updatedTo?: string;
}

function searchSubmitted({
    arriveAddress,
    arrivePlaceId,
    departAddress,
    departPlaceId,
    isOneWay,
    outboundDateSearched,
    paxCount,
    returnDateSearched,
}: SearchSubmittedArgs) {
    amplitude.track('Search Submitted', {
        arrive_address: arriveAddress,
        arrive_place_id: arrivePlaceId,
        depart_address: departAddress,
        depart_place_id: departPlaceId,
        is_one_way: isOneWay,
        outbound_date_searched: outboundDateSearched,
        pax_count: paxCount,
        return_date_searched: returnDateSearched,
    });
}

function searchFormInteracted({
    interactionType,
    updatedFrom,
    updatedTo,
}: SearchFormInteractedArgs) {
    amplitude.track('Search Form Interacted', {
        interaction_type: interactionType,
        updated_from: updatedFrom,
        updated_to: updatedTo,
    });
}

export default { searchFormInteracted, searchSubmitted };
